import { render, staticRenderFns } from "./SortingColumn.vue?vue&type=template&id=a406a4a4"
import script from "./SortingColumn.vue?vue&type=script&lang=js"
export * from "./SortingColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports